// src/components/filter.
import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';

import {
    Col,
    Row,
} from "reactstrap"
//import components
import Breadcrumbs from 'components/_Common/Breadcrumb';
import { withTranslation } from "react-i18next";
import { listSurvey } from "store/actions";
import { useDispatch, useSelector } from "react-redux";

const PhaseOne = props => {
    //meta title
    document.title = `${props.t("Survey Phase One")}  | ${props.t("Participant")}`;

    const { surveyData, loading, error, successMsg } = useSelector((state) => state.Survey);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // list
    const fetchSurveyData = () => {
        dispatch(listSurvey("participant"))
    }
    useEffect(() => {
        fetchSurveyData();
    }, []);

    const onNext = () => {
        if (surveyData?.survey?.phase_two?.length <= 0) {
            navigate('/complete-self-servey/phase-three', { state: { surveyData: surveyData } });
            return;

        }
        navigate('/complete-self-servey/phase-two', { state: { surveyData: surveyData } });
    }

    useEffect(() => {
        if (surveyData?.survey_status == "complete") {
            navigate('/dashboard')
        }
    }, [surveyData])


    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Row>
                        {
                            loading ?
                                <div className="loader d-flex justify-content-center align-items-center mt-5 " >
                                    <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                    {props.t("Loading")}
                                </div>
                                :
                                // <div className="self-survey-main">
                                //     {
                                //         surveyData?.survey_status == 'pending' || surveyData?.survey_status == 'in-progress'
                                //             ?
                                //             <>
                                //                 <div className="self-survey-inner" dangerouslySetInnerHTML={{ __html: surveyData?.survey?.phase_one }} />
                                //                 <div className="self-survey-inner-btn-div">
                                //                     <button className="self-survey-btn" onClick={() => onNext()}>{props.t('Next')}</button>
                                //                 </div>
                                //             </>
                                //             :
                                //             <>
                                //                 <div className="text-center self-survey-inner-btn-div thank-you-cnt">
                                //                     <h4>{errorMessage ? errorMessage : props.t("Thank you for submit survey")}</h4>
                                //                 </div>
                                //             </>
                                //     }

                                // </div>

                                <div className="self-survey-main">

                                    <>
                                        <div className="self-survey-title">
                                            <h3>{props.t("Your Self-Assessment – Required")}</h3>
                                        </div>
                                        <div className="self-survey-inner" dangerouslySetInnerHTML={{ __html: surveyData?.survey?.phase_one }} />
                                        <div className="self-survey-inner-btn-div">
                                            <button className="self-survey-btn" onClick={() => onNext()}>{props.t('Next')}</button>
                                        </div>
                                    </>


                                </div>
                        }
                    </Row>
                </div>
            </div>
        </React.Fragment>
    );
}

PhaseOne.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(PhaseOne);
